module.exports = __webpack_public_path__ + "img/logo1.67abd623.png";